import { get } from '@kb-front/common/fetch'

export function getAllUsers() {
  return get('/api/users')
}
